import { controlPanelRoutePaths } from './path-model';

export interface ControlPanelMenuItemConfig {
  label: string;
  to: string;
}

export const CONTROL_PANEL_MENU_ITEMS: ControlPanelMenuItemConfig[] = [
  { label: 'Ciclos', to: controlPanelRoutePaths.cycles },
  { label: 'Categorias', to: controlPanelRoutePaths.categories },
  { label: 'Avaliadores', to: controlPanelRoutePaths.evaluators },
];
